<template>
  <div class="col s6 m3" @click="detalhes()" style="height: auto;margin-bottom: 10px">
    <div class="frame-square">
      <div class="crop">
        <!-- <span class="notify-badge" v-if="produto.promocao == 'S'">Promoção</span> -->
        <span class="notify-badge cor-primaria-bg" v-if="produto.promocao == 'S' && (produto.descricao_promocao == null || produto.descricao_promocao == '')">Promoçao</span>
        <span class="notify-badge cor-primaria-bg" v-if="produto.promocao == 'S' && (produto.descricao_promocao != null && produto.descricao_promocao != '')">{{produto.descricao_promocao}}</span>
        <img v-if="produto.foto" v-lazy="this.$store.state.url_files + 'produtos-capas/' + produto.foto"  class="">
        <img v-else src="https://res.cloudinary.com/sirrus/image/upload/v1612617102/delivery/modas/assets/sem-foto_bbr18f_vmyirl.jpg" >
      </div>
    </div>
    <h6 class="title text-dots"><a href="#" style="font-size:  x-small; overflow: hidden;
   text-overflow: ellipsis; display: -webkit-box; -webkit-line-clamp: 1; -webkit-box-orient: vertical;">{{produto.nome}}</a></h6>
    <div class="action-wrap">
      <div class="price-wrap h5">
        <div class="container">
          <div class=" price-new" style="">
            <strong style="font-size: small; " v-if="produto.promocao == 'S'"> {{formatarPreco(produto.valor_promocional)}}</strong>
            <strike style="font-size: 10px" v-if="produto.promocao == 'S'">{{formatarPreco(produto.valor)}}</strike>
            <strong style="font-size: small" v-if="produto.promocao == 'N'">{{formatarPreco(produto.valor)}}</strong>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Card",
  props:["produto", "emPromocao"],
  methods:{
    detalhes(){
      this.$store.commit('produto',this.produto);
      this.$router.push('/' + this.$store.state.empresa_url + '/menu/produto/' + this.produto.id)
    },
    formatarPreco(v){
      return "R$ " + parseFloat('0' + v).toFixed(2).replace(".", ",")
    }
  }
}
</script>

<style scoped>
.btn-small{
  border-radius: 15px;
  padding: 15px;
  margin-bottom: 7px;
  height: 20px;
  line-height: 2px;
  font-size: 11px;
  width: 100%;
}
.card-product:after {
  content: "";
  display: table;
  clear: both;
  visibility: hidden;
}
.card-product .img-wrap {
  border-radius: 3px 3px 0 0;
  overflow: hidden;
  position: relative;
  text-align: center;
}
.card-product .img-wrap img
{
  /*height: 150px;*/
  /*width: 150px;*/
  min-height: 150px;
  max-height: 150px;
  max-width: 100%;
  object-fit: contain;
}
.card-product .action-wrap {
  padding-top: 4px;
  margin-top: 4px; }
.card-product .bottom-wrap {
  padding: 15px;
  border-top: 1px solid #eee; }
.card-product .title {
  margin-top: 0;
  font-size: medium;
}
.card-product .info-wrap{
  overflow: hidden;
  height: auto;
  padding: 5px 10px 10px 10px;
  border-top: 1px solid #eee;
}
.card-product .price-new, .card-product .price {
  margin-right: 5px;
}
.card-product .price-old {
  color: #999;
}
.row .col {
  float: left;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: 0 0.45rem;
  min-height: 1px;
}

.badge-promo{
  width: 90%;
  padding: 1px;
  background-color: darkred;
  color: white;
  border-radius: 10px;
}

.cardss {
  position: relative;
  margin: 0rem 0 0rem 0;
  background-color: #fff;
  -webkit-transition: -webkit-box-shadow .25s;
  transition: -webkit-box-shadow .25s;
  transition: box-shadow .25s;
  transition: box-shadow .25s, -webkit-box-shadow .25s;
  border-radius: 2px;
}

.card{
  height: 300px;
}


















.frame-square, .frame-round {
  background: #fff;
  display: inline-block;
  vertical-align: top;
  /*padding: 10px;*/
  width: 160px;
  height: 160px;
  /*margin-right: 0.5em;*/
  /*margin-bottom: 0.3em;*/
}

.frame-round {
  border-radius: 50%;
  overflow: hidden;
}
.frame-round .crop {
  border-radius: 50%;
}

.crop {
  height: 100%;
  overflow: hidden;
  position: relative;
}
.crop img {
  width: 100%;
  height: 160px;
  object-fit: cover;
}

/*.retina .crop img {*/
/*  transform: scale(0.5, 0.5);*/
/*}*/




















.notify-badge{
  position: absolute;
  /* right: 1px; */
  margin-left: 5px;
  top: 5px;
  background: #8b0000bf;
  text-align: center;
  border-radius: 20px 20px 20px 20px;
  color: white;
  padding: 5px 5px;
  z-index: 9;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/app/components/Card.vue